import { InjectionToken } from '@angular/core';
import { LayoutTheme } from '../interfaces/layout-theme.interface';

/**
 * No root factory: the implementation lives in the layout domain. Layout
 * registers it on the root injector.
 */
export const LAYOUT_THEME = new InjectionToken<LayoutTheme>('LayoutTheme');
